import { Mail, MapPin, ArrowUpRight, Clock } from "lucide-react";

const EMAIL_HREF =
  "mailto:hello@pixelkare.com?subject=AI%20App%20Development%20Enquiry&body=Hi%20Pixelkare%2C%20I%27d%20like%20to%20discuss%20building%20an%20AI-powered%20app.";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-60 pointer-events-none"
          style={{
            backgroundImage:
              "radial-gradient(circle at 50% 0%, rgba(31,135,188,0.12), transparent 55%)",
          }}
        />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-16">
          <p className="overline reveal" data-testid="contact-eyebrow">
            <span className="inline-block h-1.5 w-1.5 bg-[#1f87bc] mr-3 align-middle" />
            Contact
          </p>
          <h1
            data-testid="contact-heading"
            className="font-display reveal text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] mt-8 max-w-5xl text-[#0a0a0a]"
            style={{ animationDelay: "100ms" }}
          >
            Let's build it
            <br />
            <span className="text-[#1f87bc]">this week.</span>
          </h1>
          <p
            className="reveal mt-10 text-lg md:text-xl text-[#52525b] max-w-2xl leading-relaxed"
            style={{ animationDelay: "200ms" }}
          >
            No forms, no funnels. Drop us a line — a human (and the AI behind
            them) will get back to you fast.
          </p>
        </div>
      </section>

      {/* EMAIL CARD */}
      <section
        className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-20"
        data-testid="contact-methods"
      >
        <a
          href={EMAIL_HREF}
          data-testid="contact-method-email"
          className="group block bg-white border border-black/10 p-10 md:p-16 hover-lift hover:border-[#1f87bc] transition-colors"
        >
          <div className="grid grid-cols-12 gap-8 items-end">
            <div className="col-span-12 md:col-span-9">
              <Mail className="h-8 w-8 text-[#1f87bc]" />
              <p className="overline mt-8">Email</p>
              <p className="font-display text-4xl md:text-6xl lg:text-7xl mt-4 text-[#0a0a0a] break-words">
                hello@pixelkare.com
              </p>
              <p className="mt-6 text-[#52525b] max-w-xl leading-relaxed">
                Best for detailed briefs, attachments, and async back-and-forth.
                We typically respond within one business day.
              </p>
            </div>
            <div className="col-span-12 md:col-span-3 flex md:justify-end">
              <span className="inline-flex items-center gap-2 text-[#1f87bc] font-mono uppercase text-xs tracking-[0.2em] group-hover:gap-4 transition-all">
                Compose email
                <ArrowUpRight className="h-4 w-4" />
              </span>
            </div>
          </div>
        </a>
      </section>

      {/* ADDRESS + HOURS */}
      <section
        className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24"
        data-testid="contact-meta"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 border-t border-black/10 pt-16">
          <div>
            <div className="flex items-center gap-3">
              <MapPin className="h-5 w-5 text-[#1f87bc]" />
              <p className="overline">Studio</p>
            </div>
            <h3 className="font-display text-3xl md:text-4xl text-[#0a0a0a] mt-4 leading-tight">
              Bhubaneswar, <br />
              Odisha, India.
            </h3>
            <p className="text-[#52525b] mt-4 leading-relaxed max-w-md">
              We work with clients across India, the US, the UK, and the
              Middle East — fully remote, fully async-friendly.
            </p>
          </div>

          <div>
            <div className="flex items-center gap-3">
              <Clock className="h-5 w-5 text-[#1f87bc]" />
              <p className="overline">Response time</p>
            </div>
            <h3 className="font-display text-3xl md:text-4xl text-[#0a0a0a] mt-4 leading-tight">
              Within 24 hours <br />
              <span className="text-[#a1a1aa]">on business days.</span>
            </h3>
            <p className="text-[#52525b] mt-4 leading-relaxed max-w-md">
              Urgent project? Mention it in the subject line and we'll
              prioritise the thread.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="border-t border-black/10 bg-[#f3f1ec]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 text-center">
          <h2 className="font-display text-4xl md:text-6xl text-[#0a0a0a] leading-[1]">
            One email away from
            <br />
            <span className="text-[#1f87bc]">your live product.</span>
          </h2>
          <a
            href={EMAIL_HREF}
            data-testid="contact-final-email"
            className="mt-10 inline-flex items-center gap-3 bg-[#1f87bc] hover:bg-[#176d99] text-white px-8 py-4 font-medium transition-colors"
          >
            <Mail className="h-5 w-5" />
            hello@pixelkare.com
          </a>
        </div>
      </section>
    </div>
  );
}
